import { useEffect, useState } from "react";

import Button from "../components/Button";
import { FONT_SETTINGS } from "../fonts";
import FoundryLink from "../components/FoundryLink";
import HomeText from "../components/HomeText";
import { PageFadeWrapper } from "../components/PageWrapper";
import ProductCard from "../components/shop/ProductCard";
import Routes from "../routes";
import Separator from "../components/Separator";
import { debounce } from "../util/debounce";
import { push } from "../util/routing";
import usePhysicalProducts from "../hooks/usePhysicalProducts";
import { useRouter } from "next/router";

function Home() {
  const router = useRouter();
  const physicalProducts = usePhysicalProducts();
  const [windowWidth, setWindowWidth] = useState(1000);

  useEffect(() => {
    if (!process.env.NEXT_PUBLIC_ENABLE_FOUNDRY) {
      push(router, Routes.shop.index);
    }
  }, []);

  useEffect(() => {
    setWindowWidth(window.innerWidth / window.devicePixelRatio);
    const debouncedHandleResize = debounce(function handleResize() {
      setWindowWidth(window.innerWidth / window.devicePixelRatio);
    }, 100);

    window.addEventListener("resize", debouncedHandleResize);

    return () => {
      window.removeEventListener("resize", debouncedHandleResize);
    };
  }, []);

  if (process.env.NEXT_PUBLIC_ENABLE_FOUNDRY) {
    const lastFontColor =
      Object.values(FONT_SETTINGS)[Object.values(FONT_SETTINGS).length - 1]
        .accentColor;
    const gradient = `linear-gradient(var(--color-${lastFontColor}) 0%, var(--color-secondary) 50% 100%)`;

    return (
      <PageFadeWrapper>
        <div>
          {Object.values(FONT_SETTINGS).map((family, index) => {
            let gradient;

            if (index === 0) {
              const currColor = family.accentColor;
              const nextColor =
                Object.values(FONT_SETTINGS)[index + 1].accentColor;
              gradient = `linear-gradient(var(--color-${currColor}) 0% 50%, var(--color-${nextColor}) 150%)`;
            } else if (index === Object.values(FONT_SETTINGS).length - 1) {
              const prevColor =
                Object.values(FONT_SETTINGS)[index - 1].accentColor;
              const currColor = family.accentColor;
              gradient = `linear-gradient(var(--color-${prevColor}) -50%, var(--color-${currColor}) 50% 100%)`;
            } else {
              const prevColor =
                Object.values(FONT_SETTINGS)[index - 1].accentColor;
              const currColor = family.accentColor;
              const nextColor =
                Object.values(FONT_SETTINGS)[index + 1].accentColor;
              gradient = `linear-gradient(var(--color-${prevColor}) -50%, var(--color-${currColor}) 50%, var(--color-${nextColor}) 150%)`;
            }

            return (
              <FoundryLink
                href={Routes.fonts.family(family.name.toLowerCase())}
              >
                <section
                  className={`w-full h-screen flex flex-col items-center justify-center text-center container-full`}
                  style={{
                    background: gradient,
                  }}
                >
                  <HomeText
                    isFirst={index === 0}
                    family={family}
                    windowWidth={windowWidth}
                  ></HomeText>
                </section>
              </FoundryLink>
            );
          })}
          <div
            className="container-full theme-dark flex flex-col gap-4 items-center"
            style={{ background: gradient }}
          >
            {physicalProducts.length > 0 && (
              <>
                <Separator hideLeft={true} classes="mb-2" />
                <div className="py-24 xl:py-48 flex flex-col items-center">
                  <div
                    className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-y-6 gap-x-8 mb-24"
                    style={{ maxWidth: "1800px" }}
                  >
                    {physicalProducts.slice(0, 8).map((p) => {
                      return (
                        <ProductCard
                          product={p}
                          hidePricing={true}
                          hideButton={true}
                        ></ProductCard>
                      );
                    })}
                  </div>
                  <Button onClick={() => push(router, Routes.shop.index)}>
                    Shop products
                  </Button>
                </div>
              </>
            )}
          </div>
        </div>
      </PageFadeWrapper>
    );
  } else {
    return <></>;
  }
}

Home.displayName = "Home";
export default Home;
